import { render, staticRenderFns } from "./HisMovimiento.vue?vue&type=template&id=8d0b519e&scoped=true"
import script from "./HisMovimiento.vue?vue&type=script&lang=js"
export * from "./HisMovimiento.vue?vue&type=script&lang=js"
import style0 from "./HisMovimiento.vue?vue&type=style&index=0&id=8d0b519e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0b519e",
  null
  
)

export default component.exports